/**
 * Removes a link by id search.
 *
 * @param {Correlation} correlation
 * @param {string} id
 */
export function removeLink(correlation, id) {
    correlation.link = correlation.link.filter((_link) => _link.id !== id);
    return correlation;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVtb3ZlTGluay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvY29ycmVsYXRpb24vcmVtb3ZlTGluay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTs7Ozs7R0FLRztBQUNILE1BQU0sVUFBVSxVQUFVLENBQUMsV0FBd0IsRUFBRSxFQUFVO0lBQzdELFdBQVcsQ0FBQyxJQUFJLEdBQUcsV0FBVyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7SUFDdkUsT0FBTyxXQUFXLENBQUM7QUFDckIsQ0FBQyJ9